import { render, staticRenderFns } from "./PatientReport.vue?vue&type=template&id=fb522824&scoped=true&"
import script from "./PatientReport.vue?vue&type=script&lang=js&"
export * from "./PatientReport.vue?vue&type=script&lang=js&"
import style0 from "./PatientReport.vue?vue&type=style&index=0&id=fb522824&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb522824",
  null
  
)

export default component.exports